import React, { useState } from 'react'

interface Props {
  label: string
  placeholder: string
  value: string
  onChange: (value: string) => void
  type?: 'text' | 'email' | 'tel' | 'password'
  required?: boolean
  error?: string
  disabled?: boolean
}

const EstigroupInput = ({
  label,
  placeholder,
  value,
  onChange,
  type = 'text',
  required = false,
  error = '',
  disabled = false
}: Props): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(e.target.value)
  }

  const handleFocus = (): void => {
    setIsFocused(true)
  }
  const handleBlur = (): void => {
    setIsFocused(false)
  }

  return (
    <div className="self-stretch flex flex-col justify-start items-start gap-1">
      <div className="inline-flex justify-start items-center gap-1">
        <div className="justify-center text-web-text-body text-sm font-normal leading-tight">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </div>
      </div>
      <div
        style={{
          boxShadow: isFocused
            ? '0px 0px 0px 2px rgba(53, 130, 206, 0.2), 0px 1px 2px 0px rgba(0,0,0,0.12)'
            : '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
        }}
        className={`self-stretch px-3 py-2 bg-backgrounds-bg-field rounded-md inline-flex justify-start items-center gap-1 overflow-hidden transition-all duration-200 ${
          error.length > 0 ? 'border-red-500' : ''
        } ${isFocused ? 'ring-2 ring-Estigroup-primary ring-opacity-20' : ''}`}>
        <input
          type={type}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          disabled={disabled}
          className="w-full bg-transparent border-none outline-none font-normal leading-tight placeholder:text-foregrounds-fg-muted text-web-text-body text-[16px]"
        />
      </div>
      {error.length > 0 && <div className="text-red-500 text-xs font-normal leading-tight">{error}</div>}
    </div>
  )
}

export default EstigroupInput
